export const mainContainer = {
    width: '10.8125rem',
    transform: 'translate(-50%, -100%)',
    display: 'block',
    textDecoration: 'none',
};

export const container = ({ theme: { colors } }) => ({
    backgroundColor: colors.cyan,
    width: '100%',
    display: 'flex',
    minHeight: '2.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '600',
});

export const extendText = {
    text: () => ({
        fontWeight: '600',
    }),
};

export const triangle = ({ theme: { colors } }) => ({
    width: 0,
    height: 0,
    borderLeft: `1rem solid transparent`,
    borderRight: `1rem solid transparent`,
    borderTop: `1.125rem solid ${colors.cyan}`,

    marginTop: '0.25rem',
    marginBottom: '0.25rem',
    marginLeft: `auto`,
    marginRight: `auto`,
});
